import { createSelector } from "@reduxjs/toolkit"

export const selectMessages = (state) => {
  return state.messages.messages
}
